// Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import { Inject, Injectable } from '@angular/core';
import { WINDOW } from '../app/window.providers';

@Injectable({providedIn: 'root'})
export class WindowService {
    // would be nice if it were type Window, "private window: Window", but we need to make it any,
    // so we can use window.msCrypto.
    constructor(@Inject(WINDOW) private window: any) { }

    getHostName(): string {
        return this.window.location.hostname;
    }

    getOrigin(): string {
        return this.window.location.origin;
    }

    inIframe(): boolean {
        try {
            return this.window.self !== this.window.top;
        } catch(e) {
            return true;
        }
    }

    cryptoRandom() {
        const randomBuffer = new Uint32Array(1);
        (this.window.crypto || this.window.msCrypto).getRandomValues(randomBuffer);
        return (randomBuffer[0] / (0xffffffff + 1));
    }

}
